import React from 'react'
import { Form, FormItem, Input, Radio, SubmitButton, Switch } from 'formik-antd'
import { Col, Divider, Row, Typography } from 'antd'
import { SaveOutlined } from '@ant-design/icons'
import { Formik } from 'formik'
import { CompanyData } from '../../../services/api/companies'
import { LabeledGroup } from '../../../components'

type Props = {
  initialValues: CompanyData
  onSubmit: (form: CompanyData, ...args: any[]) => void
}
const { Text } = Typography
const { TextArea } = Input

export const View: React.FunctionComponent<Props> = ({
  initialValues,
  onSubmit,
}) => {
  return (
    <>
      <h1> Редактирование компании </h1>

      <Divider />

      <Formik<CompanyData> initialValues={initialValues} onSubmit={onSubmit}>
        <Form layout="vertical" size="large">
          <Row gutter={[32, 0]}>
            <Col span={8}>
              <FormItem name="name" label="Название">
                <Input name="name" />
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem name="manager" label="Генеральный директор">
                <Input name="manager" />
              </FormItem>
            </Col>
          </Row>

          <Row gutter={[32, 0]}>
            <Col span={6}>
              <FormItem name="inn" label="ИНН">
                <Input name="inn" />
              </FormItem>
            </Col>

            <Col span={6}>
              <FormItem name="kpp" label="КПП">
                <Input name="kpp" />
              </FormItem>
            </Col>

            <Col span={6}>
              <FormItem name="bic" label="БИК">
                <Input name="bic" />
              </FormItem>
            </Col>

            <Col span={6}>
              <FormItem name="account" label="Расчетный счет">
                <Input name="account" />
              </FormItem>
            </Col>
          </Row>

          <Row gutter={[32, 0]}>
            <Col span={24}>
              <FormItem name="businessAddress" label="Юридический адрес">
                <TextArea name="businessAddress" rows={2} />
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem name="postalAddress" label="Почтовый адрес">
                <TextArea name="postalAddress" rows={2} />
              </FormItem>
            </Col>
          </Row>

          <Divider />

          <Row gutter={[32, 0]}>
            <Col span={12}>
              <FormItem name="commission.type" label="Тип наценки">
                <Radio.Group name="commission.type">
                  <Radio name="commission.type" value="fixed">
                    Фиксированная
                  </Radio>
                  <Radio name="commission.type" value="relative">
                    Процент
                  </Radio>
                </Radio.Group>
              </FormItem>
            </Col>

            <Col span={12}>
              <FormItem name="commission.amount" label="Наценка">
                <Input name="commission.amount" />
              </FormItem>
            </Col>
          </Row>

          <Divider />

          <Row gutter={[32, 0]}>
            <Col span={24}>
              <Text disabled> Данные подписанта </Text>
            </Col>
          </Row>

          <Row gutter={[32, 0]}>
            <Col span={6}>
              <FormItem name="signer.position" label="Должность">
                <Input name="signer.position" />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name="signer.firstName" label="Имя">
                <Input name="signer.firstName" />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name="signer.middleName" label="Отчество">
                <Input name="signer.middleName" />
              </FormItem>
            </Col>
            <Col span={6}>
              <FormItem name="signer.lastName" label="Фамилия">
                <Input name="signer.lastName" />
              </FormItem>
            </Col>
          </Row>

          <Divider />

          <Row gutter={[32, 0]}>
            <Col span={24}>
              <Text disabled> Настройки организации </Text>
              <FormItem name="ordersEnabled">
                <LabeledGroup>
                  Создание заказов / покупка билетов:
                  <Switch name="ordersEnabled" />
                </LabeledGroup>
              </FormItem>
            </Col>
          </Row>

          <Divider />

          <SubmitButton>
            <SaveOutlined />
            Сохранить
          </SubmitButton>
        </Form>
      </Formik>
    </>
  )
}
